import React from "react";

export function SearchInput({searchString, setSearchString, placeholder}) {
    return (
        <input className="form-control search shadow-none" value={searchString} onChange={setSearchString}
               type="search" autoFocus placeholder={placeholder}/>
    )
}